export const QUESTION = `How often you've been feeling stressed or anxious over the last week?`

export const OPTION_VALUES = {
  NEVER: 'never',
  ONE_TWO_TIMES: 'one_two_times',
  THREE_FOR_TIMES: 'three_for_times',
  ALMOST_EVERYDAY: 'almost_everyday',
}
